import React, { Component } from 'react';
import { Switch, Route, HashRouter } from 'react-router-dom';
import "./rulesPolicies.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import DeleteModal from 'LIBRARY/CommonResources/DeleteModal/DeleteModal';
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import Pagination from 'react-js-pagination';
import { connect } from 'react-redux';
import Holidays from './Holidays/Holidays';

class RulesPolicies extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'rules',
        }
    }


    // METHOD TO SELECT EVENT TYPE
    selectEventType = (type) => {
        if (this.state.activeTab != type) {
            this.setState({
                activeTab: type
                // filterDateType: (type == 'rules') ? (this.state.filterDateType == 'all' ? '' : this.state.filterDateType) : this.state.filterDateType,
                // filterFromDate: (type == 'posted') ? (this.state.filterDateType == 'all' ? '' : this.state.filterFromDate) : this.state.filterFromDate,
                // filterToDate: (type == 'registered') ? (this.state.filterDateType == 'all' ? '' : this.state.filterToDate) : this.state.filterToDate
            })
            // , () => {
            //     if (type != 'registered') {
            //         this.setState({
            //             pageIndex: 1
            //         }, () => {
            //             // METHOD CALLED TO GET EVENT DETAILS
            //             this.apiCallToGetEventDetails();
            //         });
            //     } else {
            //         this.setState({
            //             registeredPageIndex: 1
            //         }, () => {
            //             // METHOD CALLED TO GET REGISTERED EVENT DETAILS
            //             this.apiCallToGetRegisteredEventDetails();
            //         });
            //     }
            // });
        }
    }

    render() {

        return (
            <>
                <RoutingMenu activeScreen="grantaccess" />
                <div className="libraryRules-container">
                    <div className="row col-md-12 pl-3">
                        <button className="btn closeDetails" title="Click to visit back to library settings" style={{ marginRight: '10px' }} onClick={() => this.props.closeRulesPolicies()} >
                            <FontAwesomeIcon className="" icon={["fa", "angle-left"]} />
                        </button>
                        &nbsp;
                        <div className="mt-1">
                            <h3 style={{ fontSize: "26px" }}>Rules and Policies</h3>
                        </div>
                    </div>
                    <div className="pl-4 col-md-12 mt-3">
                        <div className="ruleLinks">
                            <p className={this.state.activeTab == 'rules' ? 'activeTab settingTabs' : 'settingTabs'} onClick={() => this.selectEventType('rules')}>Rules</p>
                            <p className={this.state.activeTab == 'policies' ? 'activeTab settingTabs' : 'settingTabs'} onClick={() => this.selectEventType('policies')}>Policies</p>
                            <p className={this.state.activeTab == 'holidays' ? 'activeTab settingTabs' : 'settingTabs'} onClick={() => this.selectEventType('holidays')}>Holidays & Week Offs <span style={{fontSize:'12px'}}>(Only for Students)</span></p>
                        </div>
                        {
                            this.state.activeTab == 'rules' ?
                                (<div>
                                    <iframe
                                        src={`${config.RootUrl}/faculty/library/rules/rulesHTML.php?isIframe=true&type=rules`}
                                        className="ruleIframe"
                                    >
                                    </iframe>
                                </div>)
                                :
                                this.state.activeTab == 'policies' ?
                                    (<div className='pt-2'>
                                        <iframe
                                            src={`${config.RootUrl}/faculty/library/rules/rulesHTML.php?isIframe=true&type=policies`}
                                            className="ruleIframe"
                                        >
                                        </iframe>
                                    </div>)
                                    :
                                    (<Holidays />)
                        }
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        assignedInstitute: { ...store.RouteMenuReducer.assignedInstitute },
        assignedIIDArray: { ...store.RouteMenuReducer.assignedIIDArray },
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin
    };
};


export default connect(mapStateToProps)(RulesPolicies);
